import template from './trip-item-cancellation.html';
import tripEvents from './../config/events.constant';
import suppliers from './../../../modules/supplier/suppliers';

const DIRECTIVE_NAME = TripItemCancellation.DIRECTIVE_NAME = 'ktTripItemCancellation';
export default function TripItemCancellation() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripItemCancellationController,
        controllerAs: 'tripItemCancellationCtrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            type: `@${DIRECTIVE_NAME}Type`,
            cancellation: `=${DIRECTIVE_NAME}Cancellation`,
            cancelTrip: `=${DIRECTIVE_NAME}CancelTrip`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripItemCancellationController(
    $scope,
    tripDetailsService,
    tripItemCancellationService,
    l10nService,
) {
    'ngInject';
    const vm = this;

    const TYPE_RAIL = 'Rail';

    Object.assign(vm, {
        $onInit,
        isConfirmationSectionVisible,
        doCancellation,
        isRailsFormOptionsVisible,
        hideCancellationForm,
        isBookingComCancellationMessageVisible,
        isRailPartiallyRefundable,
        isRailNonrefundable,
        l10nService,

        isTripItemCancellable: () => tripItemCancellationService.isTripItemCancellable(vm.cancellation),
        areCostsMayBeIncurred: () => tripItemCancellationService.areCostsMayBeIncurred(vm.cancellation)
            && (this.form.type !== TYPE_RAIL
            || !this.cancellation.cancellingWholeTrip),
        isNonRefundableBooking: () => tripItemCancellationService.isNonRefundableBooking(vm.cancellation),
        isNoChargeForCancelling: () => tripItemCancellationService.isNoChargeForCancelling(vm.cancellation),

        tripItemCancellationForm: null,
        cancellationStatus: null,
    });

    const TYPE_HOTEL = 'Hotel';

    function $onInit() {
        vm.form = tripItemCancellationService.getForm(vm.cancellation, vm.model, vm.type);
        $scope.$watch(isFormValid, (value) => vm.form.isFormValid = value);
    }

    function hideCancellationForm() {
        vm.tripItemCancellationForm.$setPristine();
        tripItemCancellationService.hideCancellationForm(vm.cancellation);
    }

    function isFormValid() {
        if (vm.tripItemCancellationForm) {
            return vm.tripItemCancellationForm.$valid;
        }
        return true;
    }

    function isConfirmationSectionVisible() {
        if (tripDetailsService.isTripCancelled(vm.tripDetails)) {
            return false;
        }
        if (tripItemCancellationService.isTripCancellation(vm.cancellation)) {
            return isRailsFormOptionsVisible();
        }
        if (!tripItemCancellationService.isTripItemCancellation(vm.cancellation)) {
            return false;
        }
        const {cancellationItemMsg} = vm.cancellation;
        const {id, type} = cancellationItemMsg.item;
        return vm.model.Id === id
            && vm.type === type;
    }

    function isRailsFormOptionsVisible() {
        return tripItemCancellationService.isTripConfirmed(vm.cancellation)
            && tripItemCancellationService.isTripItemConfirmed(vm.model)
            && vm.type === TYPE_RAIL
            && tripItemCancellationService.ticketsReturnIsRequiredForRefund(vm.model);
    }

    function doCancellation() {
        vm.tripItemCancellationForm.$setSubmitted(true);

        if (!isFormValid()) {
            return;
        }

        const isOnlyOneItemInTrip = tripDetailsService.getTripItemsCount(vm.tripDetails) === 1;
        if (isOnlyOneItemInTrip) {
            vm.cancelTrip(vm.tripItemCancellationForm);
            return;
        }

        tripItemCancellationService
            .cancelTripItem(vm.cancellation, vm.tripItemCancellationForm)
            .then(() => $scope.$emit(tripEvents.TRIP_DETAILS_UPDATE));
    }

    function isBookingComCancellationMessageVisible() {
        return isBookingComProduct()
            && tripItemCancellationService.isTripItemConfirmed(vm.model);
    }

    function isBookingComProduct() {
        return vm.type === TYPE_HOTEL
            && vm.model
            && vm.model.Supplier === suppliers.bookingCom.id;
    }

    function isRailPartiallyRefundable() {
        if (this.form.type !== TYPE_RAIL) {
            return false;
        }

        if (this.cancellation.cancellingWholeTrip) {
            return false;
        }

        return this.form.item.CanBeRefunded
            && this.form.item.TotalPrice.Amount - this.form.item.CreditCardFee.Amount > this.form.item.RefundablePrice.Amount;
    }

    function isRailNonrefundable() {
        if (this.form.type !== TYPE_RAIL) {
            return false;
        }

        if (this.cancellation.cancellingWholeTrip) {
            return false;
        }

        return !this.form.item.CanBeRefunded;
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation/trip-item-cancellation-component.js